import { api } from './api';

export type SearchResultType = 'prospect' | 'opportunity' | 'contact';

export interface SearchResult {
  type: SearchResultType;
  id: string;
  title: string;
  subtitle: string | null;
  link: string;
}

export interface SearchResponse {
  query: string;
  groups: {
    prospects: SearchResult[];
    opportunities: SearchResult[];
    contacts: SearchResult[];
  };
  totalCount: number;
}

export const searchApi = {
  global: (token: string, q: string) =>
    api.get<SearchResponse>(`/api/v1/search?q=${encodeURIComponent(q)}`, { accessToken: token }),
};
